var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    color: "#009688",
    width: 64,
    height: 64,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 43 h 43 V 8.573 C 90 3.846 86.154 0 81.428 0 H 47 V 43 z M 59.704 19 h 17.592 c 1.381 0 2.5 1.119 2.5 2.5 s -1.119 2.5 -2.5 2.5 H 59.704 c -1.381 0 -2.5 -1.119 -2.5 -2.5 S 58.323 19 59.704 19 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,150,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 43 47 H 0 v 34.428 C 0 86.154 3.846 90 8.573 90 H 43 V 47 z M 29.487 72.952 c 0.976 0.977 0.976 2.56 0 3.535 c -0.488 0.488 -1.128 0.732 -1.768 0.732 s -1.28 -0.244 -1.768 -0.732 L 21.5 72.036 l -4.451 4.452 c -0.488 0.488 -1.128 0.732 -1.768 0.732 s -1.279 -0.244 -1.768 -0.732 c -0.977 -0.976 -0.977 -2.559 0 -3.535 l 4.452 -4.452 l -4.452 -4.452 c -0.976 -0.977 -0.976 -2.56 0 -3.535 c 0.976 -0.977 2.559 -0.977 3.536 0 l 4.451 4.452 l 4.451 -4.452 c 0.977 -0.977 2.559 -0.977 3.536 0 c 0.977 0.976 0.977 2.559 0 3.535 L 25.036 68.5 L 29.487 72.952 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,150,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 43 0 H 8.573 C 3.846 0 0 3.846 0 8.573 V 43 h 43 V 0 z M 30.295 24 H 24 v 6.295 c 0 1.381 -1.119 2.5 -2.5 2.5 s -2.5 -1.119 -2.5 -2.5 V 24 h -6.295 c -1.381 0 -2.5 -1.119 -2.5 -2.5 s 1.119 -2.5 2.5 -2.5 H 19 v -6.295 c 0 -1.381 1.119 -2.5 2.5 -2.5 s 2.5 1.119 2.5 2.5 V 19 h 6.295 c 1.381 0 2.5 1.119 2.5 2.5 S 31.676 24 30.295 24 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,150,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47 90 h 34.428 C 86.154 90 90 86.154 90 81.428 V 47 H 47 V 90 z M 68.522 77.841 h -0.045 c -1.381 0 -2.5 -1.119 -2.5 -2.5 s 1.119 -2.5 2.5 -2.5 S 71 73.96 71 75.341 S 69.903 77.841 68.522 77.841 z M 68.478 59.159 c 1.381 0 2.522 1.119 2.522 2.5 s -1.097 2.5 -2.478 2.5 h -0.045 c -1.381 0 -2.5 -1.119 -2.5 -2.5 S 67.097 59.159 68.478 59.159 z M 59.704 66 h 17.592 c 1.381 0 2.5 1.119 2.5 2.5 s -1.119 2.5 -2.5 2.5 H 59.704 c -1.381 0 -2.5 -1.119 -2.5 -2.5 S 58.323 66 59.704 66 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,150,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.1a0101f9.svg";
export { ForwardRef as ReactComponent };